/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Share_Code_RequiredInputs */



/**
* | output |
* | --- |
* | "Share code can't be blank" |
*
* @param {Team_Project_Import_Share_Code_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_share_code_required = /** @type {((inputs?: Team_Project_Import_Share_Code_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Share_Code_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le code de partage ne peut pas être vide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Freigabecode darf nicht leer sein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il codice di condivisione non può essere vuoto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Код доступа не может быть пустым.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El código compartido no puede estar en blanco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分享码不能为空")
	if (locale === "ja") return /** @type {LocalizedString} */ ("共有コードは空白にできません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयर कोड खाली नहीं हो सकता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O código de compartilhamento não pode estar em branco.")
	return /** @type {LocalizedString} */ ("Share code can't be blank")
});